import React, { createContext, useReducer } from 'react'
import PropTypes from 'prop-types'
import globalReducer from './globalReducer'

const initialState = {
  document: null,
  breadcrumbs: null,
  contentTags: null,
  contentTagsLoaded: false,
}

export const GlobalContext = createContext(initialState)

export const GlobalProvider = ({ children }) => {
  const [state, dispatch] = useReducer(globalReducer, initialState)

  const setDocument = (item) => {
    dispatch({
      type: 'SET_DOCUMENT',
      payload: item,
    })
  }

  const setBreadcrumbsGlobal = (item) => {
    dispatch({
      type: 'SET_BREADCRUMBS',
      payload: item,
    })
  }

  const setContentTagsGlobal = (item) => {
    dispatch({
      type: 'SET_CONTENT_TAGS',
      payload: item,
    })
  }

  return (
    <GlobalContext.Provider
      value={{
        document: state.document,
        setDocument,
        breadcrumbs: state.breadcrumbs,
        setBreadcrumbsGlobal,
        contentTags: state.contentTags,
        setContentTagsGlobal,
        contentTagsLoaded: state.contentTagsLoaded,
      }}
    >
      {children}
    </GlobalContext.Provider>
  )
}

GlobalProvider.propTypes = {
  children: PropTypes.array,
}
